import './CongratsClosedModal.scss'

import React from 'react'
import { connect } from 'react-redux'
import { connectModal } from 'redux-modal'
import { Button, Modal } from 'react-bootstrap'


const Congrats = ({
  handleHide,
  show,
  clientName,
}) => {
  return (
    <Modal className="CongratsClosedModal" show={show}>
      <Modal.Body>
        <div className="CongratsClosedModal__icon"/>
        <div className="CongratsClosedModal__title">
          Congratulations!
        </div>
        <div className="CongratsClosedModal__paragraph--strong">
            You successfully closed your transaction with {clientName}!  We’re lucky to have you as an Opcity partner.
        </div>
        <Button className="CongratsClosedModal__close_button" onClick={handleHide} bsStyle="primary">Close Window</Button>
      </Modal.Body>
    </Modal>
  )
}

const selector = state => {
  const clientName = _.get(state, ['referral', 'referral', 'name'])

  return {
    clientName,
  }
}

const withModalHandlers = connectModal({ name: 'CongratsClosedModal', destroyOnHide: true })

const withRedux = connect(selector)

export const CongratsClosedModal = withModalHandlers(withRedux(Congrats))
